import { render, staticRenderFns } from "./SelectWidgetExtended.vue?vue&type=template&id=48e41e35"
import script from "./selectWidgetExtended.ts?vue&type=script&lang=js&external"
export * from "./selectWidgetExtended.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports